import { render, staticRenderFns } from "./sponsor_visit_admin.vue?vue&type=template&id=6d8797c2&scoped=true&"
import script from "./sponsor_visit_admin.vue?vue&type=script&lang=js&"
export * from "./sponsor_visit_admin.vue?vue&type=script&lang=js&"
import style0 from "./sponsor_visit_admin.vue?vue&type=style&index=0&id=6d8797c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8797c2",
  null
  
)

export default component.exports